import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-improve_resume",
  "use": "icon-improve_resume-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-improve_resume\"><path d=\"M22.5 6h-15v24h21V12h-6V6Zm-18-1.512C4.5 3.666 5.17 3 5.998 3H24l7.5 7.5v20.99A1.5 1.5 0 0 1 30.01 33H5.99a1.5 1.5 0 0 1-1.49-1.488V4.488ZM18 17.25a3.75 3.75 0 1 1 0-7.5 3.75 3.75 0 0 1 0 7.5Zm-6.71 8.25a6.75 6.75 0 0 1 13.42 0H11.29Z\" fill=\"#666\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol